// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:37
import { TmpTextObject_abstract } from './../abstract/SagaBase/TmpTextObject_abstract';
export class TmpTextObject extends TmpTextObject_abstract {}
